module.exports = __webpack_public_path__ + "static/mac.9fcdf544.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mac.png
// module id = 561
// module chunks = 54681204059826